import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import touchDevise from './lib/detectTouch';

const sectionNode = document.querySelector('.js-section-museum');
const sliderNode = document.querySelector('.js-museum-slider');
const slideNodes = [...sliderNode.querySelectorAll('.js-item')];

let tl;
const opacityTls = [];

const createOpacityTl = () => {
  slideNodes.forEach((slide, i) => {
    // console.log(sectionNode.getBoundingClientRect().bottom - sliderNode.getBoundingClientRect().bottom);
    opacityTls[i] = gsap.timeline({
      scrollTrigger: {
        id: `opacityFromTl${i}`,
        trigger: sliderNode,
        scrub: 0,
        scroller: '[data-scroll-container]',
        // markers: true,
        start: () => `top+=${slideNodes.reduce((acc, s, index) => index < i ? acc + s.offsetWidth: acc, (sectionNode.getBoundingClientRect().bottom - sliderNode.getBoundingClientRect().bottom))} bottom`,
        end: () => `+=${slide.offsetWidth}`,
      },
    }).fromTo(slide.querySelector('.js-light'), {opacity: 0}, {opacity: 1}, 0);

    opacityTls[i] = gsap.timeline({
      scrollTrigger: {
        id: `opacityToTl${i}`,
        trigger: sliderNode,
        scrub: 0,
        scroller: '[data-scroll-container]',
        // markers: true,
        start: () => `top+=${slideNodes.reduce((acc, s, index) => index <= i ? acc + s.offsetWidth : acc, (sectionNode.getBoundingClientRect().bottom - sliderNode.getBoundingClientRect().bottom))} bottom`,
        end: () => `+=${slide.offsetWidth}`,
      },
    }).to(slide.querySelector('.js-light'), {opacity: 0}, 0);
  }) 
}

const clearOpacityTl = () => {
  slideNodes.forEach((slide, i) => {   
    gsap.set([slide.querySelector('.js-light')], {clearProps: 'all'});
    ScrollTrigger.getById(`opacityFromTl${i}`).kill(true);
    ScrollTrigger.getById(`opacityToTl${i}`).kill(true);
  })
}

const createTimeLine = () => {
  const coef = 1;
  // const coef = touchDevise() ? 1.5 : 1;
  return gsap.timeline({
    scrollTrigger: {
      id: 'triggerMuseum',
      trigger: sectionNode,
      pin: true,
      scrub: 0,
      start: 'bottom bottom',
      scroller: '[data-scroll-container]',
      // markers: true,
      end: () => `+=${(sliderNode.offsetWidth - slideNodes[0].offsetWidth + 60) * coef}`,
    },
    // onUpdate: () => { update(tl.progress()) }
  })
  .to(sliderNode, {
    x: () => `-=${sliderNode.offsetWidth - slideNodes[0].offsetWidth + 60}`,
    ease: 'none',
  }, 0)
}

const slider = {
  init: () => {
    tl = createTimeLine();
    // update(0);
    createOpacityTl();
    ScrollTrigger.refresh();
  },
  resize: () => {
    const progress = tl.progress();
    
    gsap.set([sliderNode, sectionNode], {clearProps: 'all'});
    ScrollTrigger.getById('triggerMuseum').kill(true);

    tl = createTimeLine();
    // update(progress);
    tl.progress(progress);

    clearOpacityTl();
    createOpacityTl();
  }
}

export default slider;